import { useRef }                       from "react";
import { Cancel }                       from "@mui/icons-material";
import { Stack, TextField, Typography } from "@mui/material";
import { Box }                          from "@mui/system";

const Tags = ({ data, handleDelete }) => {
	return (
		<Box
			sx={{
				background    : "indigo",
				height        : "100%",
				display       : "flex",
				padding       : "0.4rem",
				margin        : "0 0.5rem 0 0",
				justifyContent: "center",
				alignContent  : "center",
				color         : "#ffffff",
				borderRadius  : '50px'
			}}
		>
			<Stack direction='row' gap={1}>
				<Typography>{data}</Typography>
				<Cancel
					sx={{ cursor: "pointer" }}
					onClick={() => {
						handleDelete (data);
					}}
				/>
			</Stack>
		</Box>
	);
};

export default function HashTags(props) {
	const { tags, handleHashTags } = props;
	const tagRef                   = useRef ();

	const handleDelete = (value) => {
		const newtags = tags.filter ((val) => val !== value);
		handleHashTags (newtags);
	}

	const handleOnSubmit = (e) => {
		e.preventDefault ();
		handleHashTags ([...tags, tagRef.current.value]);
		tagRef.current.value = "";
	}

	return (
		<Box sx={{ flexGrow: 1 }}>
			<form onSubmit={handleOnSubmit}>
				<TextField
					inputRef={tagRef}
					fullWidth
					label="Tags"
					margin='none'
					InputProps={{
						startAdornment: (
							<Box sx={{ margin: "0 0.2rem 0 0", display: "flex" }}>
								{tags.map ((data, index) => {
									return (
										<Tags data={data} handleDelete={handleDelete} key={index} />
									);
								})}
							</Box>
						),
					}}
				/>
			</form>
		</Box>
	);
}
